import { permissions } from '@dvag/dfs-constant-config';
import { IconName } from '@dvag/design-system-icons/dist/types/types/icon-types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { PersonFullName } from '../type/person';

export const STATUS_FORBIDDEN = 403;
export const STATUS_UNAUTHORIZED = 401;

export const familyRelationshipList = {
  KIND: 'KIND',
  ERWACHSEN: 'ERWACHSEN',
};

export const getPersonFullName = ({ firstName, lastName }: PersonFullName): string =>
  `${firstName} ${lastName}`;

export const useCheckPermission = (permissionKey: keyof typeof permissions) => {
  const hasPermission = useFeatureIsOn(permissions[permissionKey]);

  if (!hasPermission) {
    throw Error('Unauthorized', { cause: 403 });
  }
};

export const checkIcon = (icon: IconName): IconName => icon;

export const isSalesforceWishesAndGoals = (currentRoute: string | undefined) =>
  currentRoute?.includes('wuensche-und-ziele') && currentRoute?.endsWith('salesforce');
